import styled from "styled-components/macro";

export const TableHeaderStyled = styled.thead``;
